import { I18n } from "@assets/strings";
import React from "react";
import styled, { css } from "styled-components";
import { allApplicationMemberStatus } from "@domain/application/application";

interface ApplicationStatusProps extends React.HTMLAttributes<HTMLDivElement> {
	isComplete: boolean;
}

export const ApplicationStatus: React.FC<ApplicationStatusProps> = ({ isComplete, ...htmlProps }) => {
	return (
		<Container isComplete={isComplete} {...htmlProps}>
			{I18n.t(`application.status.${allApplicationMemberStatus[!isComplete ? 0 : 2]}`)}
		</Container>
	);
};

const Container = styled.div.withConfig({
	shouldForwardProp: (prop) => prop !== "isComplete",
})<{ isComplete: boolean }>`
	border-radius: 7px;
	padding: 1px 10px;
	display: flex;
	align-items: center;
	font-size: 14px;

	${({ isComplete, theme }) =>
		isComplete
			? css`
					background-color: ${theme.colors.winterGreen} !important;
					color: ${theme.colors.white};
				`
			: css`
					background-color: ${theme.colors.lightergray};
					border: 1px solid #e9e9e9;
				`}
`;
